import { getSupabase } from '@config/supabase';
import { edgeFunctions, supabaseConfig } from '@config/index';
import { buildLocalInfraSnapshot } from '@infra/metrics/prometheus';
import type {
  IInfraMetricsRepository,
  InfraMetricsSnapshot,
} from '@modules/infraMetrics';

export class SupabaseInfraMetricsRepository implements IInfraMetricsRepository {
  async getSnapshot(): Promise<InfraMetricsSnapshot> {
    if (process.env.NODE_ENV === 'development') {
      return this.getLocalSnapshot();
    }

    const supabase = getSupabase();
    if (!supabase) throw new Error('Supabase não configurado');

    const { data, error } = await supabase.functions.invoke<InfraMetricsSnapshot>(
      edgeFunctions.adminInfraMetrics,
      { method: 'GET' },
    );

    if (error) throw new Error(error.message || 'Falha ao consultar métricas');
    if (!data) throw new Error('A função de métricas não retornou dados');

    return data;
  }

  private async getLocalSnapshot(): Promise<InfraMetricsSnapshot> {
    const { url, serviceRoleKey } = supabaseConfig;
    if (!url || !serviceRoleKey) {
      throw new Error('Credenciais do Supabase não configuradas para o teste local');
    }

    const [response, machineResponse] = await Promise.all([
      fetch(
        `${url.replace(/\/$/, '')}/customer/v1/privileged/metrics`,
        {
          headers: {
            Authorization: `Basic ${window.btoa(`metrics:${serviceRoleKey}`)}`,
          },
        },
      ),
      fetch('/local-node-metrics').catch(() => null),
    ]);

    if (!response.ok) {
      throw new Error(`Metrics API respondeu HTTP ${response.status}`);
    }

    const machineText = machineResponse?.ok ? await machineResponse.text() : null;
    return buildLocalInfraSnapshot(await response.text(), machineText);
  }
}
